/**
* @name: government
* @author: weiyong
* @date: 2023-04-01 21:06
* @description：government
* @update: 2023-04-01 21:06
*/
<template>
  <div :class="prefixCls" class="environmentalLayout wrapper-horizontal">
    <LayoutFeatures v-if="singlePageFlag!==true" />
    <header-bar-page v-if="singlePageFlag!==true"  :settingLayout="settingLayout"></header-bar-page>
    <div class="page-content flex-div">
      <left-layout-div v-if="singlePageFlag!==true" />
      <div class="main-panel w100b">
        <MultipleTabs v-if="getShowTabs&&singlePageFlag!==true"/>
        <right-layout-div :pageTitleFlag="true" :singlePageFlag="singlePageFlag" :systemFlag="isNotSystem" :showTabs="getShowTabs"/>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import {createAsyncComponent} from "@/utils/factory/createAsyncComponent";

export default defineComponent({
  components: {
    LayoutFeatures: createAsyncComponent(() => import('@/layouts/default/feature/index.vue')),
  },
  name: "environmental",
});
</script>

<script lang="ts" setup>
import MultipleTabs from '@/layouts/default/tabs/index.vue';
import HeaderBarPage from "./components/header-bar-page.vue";
import LeftLayoutDiv from "@/layouts/layoutFrame/environmental/components/left-layout-div.vue";
import RightLayoutDiv from "@/layouts/layoutFrame/environmental/components/right-layout-div.vue";
import {useDesign} from "@/hooks/web/useDesign";
import {computed, ref, unref} from "vue";
import {useI18n} from "@/hooks/web/useI18n";
import {useMultipleTabSetting} from "@/hooks/setting/useMultipleTabSetting";
import {useFullContent} from "@/hooks/web/useFullContent";
import GoingUtils from "@/utils/goingUtils";
import {StorageUtils} from 'xmgoing-utils';
import {usePageFlush} from "@/hooks/setting/usePageFlush";
import {useRootSetting} from "@/hooks/setting/useRootSetting";


const {prefixCls} = useDesign('environmentalLayout');
const itemMenu = ref({});

const {t} = useI18n();

const props = defineProps({
  singlePageFlag:{},
  settingLayout: {
    type: Boolean,
    default: true
  }
})



const {getFullContent} = useFullContent();
const {getShowMultipleTab} = useMultipleTabSetting();
const getShowTabs = computed(() => {
  return unref(getShowMultipleTab) && !unref(getFullContent);
});
onMounted(()=>{
  if(!(document.body.className.indexOf('environmental-body')>=0)){
    document.body.className=document.body.className+" environmental-body";
  }
})

const isNotSystem=computed(()=>{
  try{
    return !GoingUtils.isSystem(JSON.parse(StorageUtils.getSessionItem("curUserJson")+"").position)
  }catch (e){
    return  false;
  }
})
//刷新界面的hook
usePageFlush();
</script>

<style type="text/css" lang="less">
@import './less/environmentalLayout.less';

.environmentalLayout {
  font-family: "Poppins", "PingFang SC", "Microsoft YaHei", "Helvetica Neue", Helvetica, "Heiti SC";
}

.singlePage{
  &.wrapper-horizontal.environmentalLayout {
    .page-content {
      height: 100%;
    }
    .getLayoutContentMode.hasPageBar > div{
      height: 100%;
    }
    .getLayoutContentMode.hasPageBar #frame{
      height: 100%;
    }
  }
  .go-page#frame{
    padding: 0;
  }
}
.wrapper-horizontal.environmentalLayout {
  --header-height: 48px;
  --el-custom-header-bg-color:'#313642';

  transition: all .3s;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  height: 100vh;
  overflow: hidden;
  font-size: var(--baseFontSize,14px);

  .page-content {
    width: 100%;
    height: calc(100% - var(--header-height, 49px));
  }

  .main-panel{
    flex: 1;
    overflow: hidden;
  }

  .divider {
    margin-left: 0;
    margin-top: 6px;
    margin-bottom: 6px;
    height: 18px;
  }

  .el-divider--vertical {
    display: inline-block;
    width: 1px;
    height: 1em;
    margin: 0 8px;
    vertical-align: middle;
    position: relative;
    border-left: 1px var(--el-border-color) var(--el-border-style);
  }
}
</style>
